import { Link } from "react-router-dom";

export function LogoMark({ className = "h-9 w-9" }) {
  return (
    <svg viewBox="0 0 64 64" className={className} role="img" aria-label="GeoDrafts logo" data-testid="logo-mark">
      <rect width="64" height="64" rx="12" fill="#102A43" />
      <path d="M14 44 L24 16 L52 24 L42 50 Z" fill="none" stroke="#20C4C7" strokeWidth="3" strokeLinejoin="round" />
      <path d="M6 38c9-5 15 3 25-2s17 2 27-4" fill="none" stroke="#ffffff" strokeOpacity="0.8" strokeWidth="2" />
      <circle cx="24" cy="16" r="3" fill="#20C4C7" />
      <circle cx="52" cy="24" r="3" fill="#20C4C7" />
      <circle cx="42" cy="50" r="3" fill="#20C4C7" />
      <circle cx="14" cy="44" r="3" fill="#20C4C7" />
    </svg>
  );
}

export default function Logo({ variant = "dark", className = "" }) {
  const geo = variant === "light" ? "text-white" : "text-navy";
  return (
    <Link to="/" className={`inline-flex items-center gap-2.5 ${className}`} data-testid="logo-link" aria-label="GeoDrafts home">
      <LogoMark />
      <span className={`font-display text-xl font-extrabold tracking-tight ${geo}`}>
        Geo<span className="text-aqua">Drafts</span>
      </span>
    </Link>
  );
}
